/**
 * Session de navigateur : déconnexion après 30 min sans activité (clavier,
 * souris, toucher), vérifiée aussi au retour de veille. Tant que l'employé est
 * actif, le jeton est renouvelé toutes les 10 min, car le serveur ferme de son
 * côté une session dont le jeton n'a pas été renouvelé depuis 30 min.
 * L'activité est partagée entre les onglets : un onglet oublié ne ferme pas la
 * session d'un onglet où l'on travaille.
 */
import { ApiError, getAccessTokenAge, refreshAccessToken } from './api-client';
export const IDLE_MS = 30 * 60 * 1000;
const RENEW_MS = 10 * 60 * 1000;
const CHECK_MS = 30 * 1000;
const SHARE_EVERY_MS = 15 * 1000;
const STORAGE_KEY = 'civille_derniere_activite';
const EVENTS = ['pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart', 'scroll'];
function readShared() {
    try {
        return Number(localStorage.getItem(STORAGE_KEY)) || 0;
    }
    catch {
        return 0;
    }
}
function writeShared(time) {
    try {
        localStorage.setItem(STORAGE_KEY, String(time));
    }
    catch {
        // Stockage indisponible (navigation privée) : chaque onglet compte pour lui-même
    }
}
/** Surveille l'inactivité ; renvoie la fonction qui arrête la surveillance. */
export function watchIdle(onIdle) {
    let last = Date.now();
    let shared = last;
    let renewTried = 0;
    let ended = false;
    writeShared(last);
    const idle = () => Date.now() - Math.max(last, readShared()) >= IDLE_MS;
    const end = () => {
        if (ended)
            return;
        ended = true;
        stop();
        onIdle();
    };
    const renewIfActive = () => {
        // Un essai par période de vérification : une panne réseau ne doit pas déclencher une demande par mouvement
        if (getAccessTokenAge() < RENEW_MS || Date.now() - renewTried < CHECK_MS)
            return;
        renewTried = Date.now();
        refreshAccessToken().catch((err) => {
            // Session déjà fermée par le serveur (12 h atteintes, déconnexion ailleurs)
            if (err instanceof ApiError && err.status === 401)
                end();
        });
    };
    const onActivity = () => {
        // Retour de veille : le premier mouvement de souris ne doit pas prolonger la session
        if (idle())
            return end();
        last = Date.now();
        if (last - shared >= SHARE_EVERY_MS) {
            shared = last;
            writeShared(last);
        }
        renewIfActive();
    };
    const check = () => {
        if (idle())
            end();
    };
    const onVisible = () => {
        if (document.visibilityState === 'visible')
            check();
    };
    const timer = window.setInterval(check, CHECK_MS);
    for (const e of EVENTS)
        window.addEventListener(e, onActivity, { capture: true, passive: true });
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', check);
    function stop() {
        window.clearInterval(timer);
        for (const e of EVENTS)
            window.removeEventListener(e, onActivity, { capture: true });
        document.removeEventListener('visibilitychange', onVisible);
        window.removeEventListener('focus', check);
    }
    return stop;
}
//# sourceMappingURL=session-idle.js.map